// src/data/projects.js

export const projects = [
  {
    slug: 'arichat',
    title: 'AriChat',
    tagline: 'Real-time messaging app',
    description: 'Real-time messaging app built with React, Firebase, and JWT authentication.',
    tech: ['React', 'Firebase', 'JWT', 'Vercel'],
    demoLink: 'https://chat-app-ten-gamma-95.vercel.app/',
    featured: true,
    caseStudy: {
      pending: true,
      problem: null,
      approach: null,
      decisions: [],
      outcome: null,
    },
  },
  {
    slug: 'portfolio',
    title: 'This Portfolio',
    tagline: 'Personal site, redesigned from the ground up',
    description:
      'Personal portfolio built with React and React Router, with a hand-built CSS design system, a Firebase-backed contact form, and CI/CD to Firebase Hosting via GitHub Actions.',
    tech: ['React', 'React Router', 'Firebase', 'Framer Motion'],
    demoLink: 'https://ariankazemi.com',
    featured: true,
    caseStudy: {
      pending: false,
      problem:
        'An earlier version of this site was a functional but generic Create React App template: undefined CSS variables silently broke hover states, the intended font never loaded, SEO metadata was still the CRA boilerplate, and the project list had no real depth.',
      approach:
        'Rebuilt the design system around CSS custom properties (color, spacing, radius, shadow scales) shared through a single App.css, added scroll-driven motion with Framer Motion, and restructured content around real case studies instead of one-line project blurbs.',
      decisions: [
        {
          title: 'Plain CSS over a framework',
          detail:
            'Kept hand-written CSS with custom properties instead of pulling in Tailwind — the codebase is small enough that a framework would add build complexity without a real payoff.',
        },
        {
          title: 'Firestore for the contact form',
          detail:
            'The project already initialized Firebase but never used Firestore. Wired the contact form to write directly to a locked-down collection instead of standing up a separate backend.',
        },
        {
          title: 'CI/CD via GitHub Actions',
          detail:
            'Firebase Hosting deploys automatically on every push to main, with a separate preview-channel workflow for pull requests.',
        },
      ],
      outcome:
        'A site that accurately represents the code behind it: verified builds, working dark mode across every component, and no dead code or broken references left over from earlier iterations.',
    },
  },
  {
    slug: 'aim-trainer',
    title: 'Aim Trainer',
    tagline: 'A small reflex game built into this site',
    description:
      'A browser-based reflex/aim-training minigame — click targets as they appear, tracked for hits, accuracy, and time.',
    tech: ['React', 'JavaScript'],
    demoLink: null,
    featured: false,
    playable: true,
    caseStudy: {
      pending: false,
      problem:
        'Wanted a small, self-contained project to practice component state, timers, and DOM measurement outside of a typical form-and-fetch app.',
      approach:
        'Built as a standalone React component: a bounded game area spawns a target at a random position, tracks clicks against the target’s bounding box, and runs a countdown with React state and effects.',
      decisions: [
        {
          title: 'DOM element over canvas',
          detail:
            'The game only needs one moving element, so a positioned DOM node was simpler to reason about than setting up a canvas render loop.',
        },
        {
          title: 'Kept inside the portfolio, not a separate repo',
          detail:
            'Small enough to live as one project among the others in this codebase rather than its own deployment.',
        },
      ],
      outcome:
        'A working, playable project that lives directly in the portfolio instead of linking out to something separate — you can try it below.',
    },
  },
  {
    slug: 'steadyskull',
    title: 'SteadySkull',
    tagline: 'Fitness tracking web app',
    description:
      'Fitness tracking web app built with Next.js and MongoDB — log workouts, track progress, and view historical fitness charts.',
    tech: ['Next.js', 'React', 'MongoDB', 'Tailwind CSS'],
    demoLink: 'https://www.steadyskull.com/',
    featured: true,
    caseStudy: {
      pending: true,
      problem: null,
      approach: null,
      decisions: [],
      outcome: null,
    },
  },
];
